import React from 'react';
import Layout from 'layouts/Layout';
import ArticleList from './ArticleList';

const ArticleListLayout = ({ match }) => <Layout component={ArticleList} match={match} />;

export default ArticleListLayout;
